export default "__VITE_ASSET__GnynMqLj__"